import { useParams, useNavigate } from "react-router-dom"; // Import useNavigate
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import FloatingLabelInput from "../../Common/FloatingLabel";
import { ResetPasswordData } from "../../api/api";
import toast, { Toaster } from "react-hot-toast";
import { FaInfoCircle } from "react-icons/fa";
import { handleApiError } from "../../Common/Helper";
const ResetPassword = () => {
  const { token } = useParams(); // Retrieve token from URL parameters
  const navigate = useNavigate(); // Initialize navigate
  const [errors, setErrors] = useState({});
  // Validation schema with Yup
  const validationSchema = Yup.object({
    password: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .required("Password is required"),
    confirm_password: Yup.string()
      .oneOf([Yup.ref("password")], "Passwords must match")
      .required("Confirm Password is required"),
  });

  // Initialize Formik
  const formik = useFormik({
    initialValues: {
      password: "",
      confirm_password: "",
    },
    validationSchema,
    onSubmit: (values) => {
      const data = {
        token, // Add token to API data
        password: values.password,
        password_confirmation: values.confirm_password, // Map confirm_password to password_confirmation
      };

      ResetPasswordData(data)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            console.log("success");
            toast.success("Password reset successfully");
            setTimeout(() => {
              navigate("/"); // Redirect to login page
            }, 2000); // Redirect after 2 seconds
          } else {
            handleApiError(res,navigate);
          }
        })
        .catch((err) => {
          const errorMessage = err?.error || "An error occurred";
          toast.error(errorMessage);
        });
    },
  });

  return (
    <>
      <Toaster />
      <div className="container">
        <div className="grid grid-cols-2 max-md:grid-cols-1 text-black">
          <div className="flex justify-center items-center h-screen">
            <div className="bg-[#fff] w-full mx-auto px-[40px] py-[20px] h-auto rounded-lg">
              <h3 className="text-[20px] font-bold">Reset Your Password!</h3>
              <form onSubmit={formik.handleSubmit}>
                <input type="hidden" name="token" value={token} />

                <div className="my-5">
                  <FloatingLabelInput
                    label="Change Password"
                    type="password"
                    id="password"
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.password && formik.errors.password ? (
                    <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                      <FaInfoCircle />
                      <p className="text-white py-1 px-2 text-sm my-2">
                        {formik.errors.password}
                      </p>
                    </div>
                  ) : null}
                </div>
                <div>
                  <FloatingLabelInput
                    label="Confirm Password"
                    type="password"
                    id="confirm_password"
                    name="confirm_password"
                    value={formik.values.confirm_password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.confirm_password &&
                  formik.errors.confirm_password ? (
                    <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                      <FaInfoCircle />
                      <p className="text-white py-1 px-2 text-sm my-2">
                        {formik.errors.confirm_password}
                      </p>
                    </div>
                  ) : null}
                </div>
                <div>
                  <button
                    type="submit"
                    className="w-full py-3 mt-3 text-white font-bold bg-primary rounded"
                    disabled={formik.isSubmitting}
                  >
                    Reset Password
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="max-lg:hidden">
            <div className="fixed bottom-0 2xl:w-[800px] lg:w-[500px] right-[6%] flex justify-center">
              <img
                src="/assets/images/1.png"
                alt="wills-guru-logo-white"
                className="h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;